import React from 'react'
import './style.scss'

const services = [
    { icon: 'fi flaticon-lawyer', subtitle: 'Book Your', title: 'Appointment' },
    { icon: 'fi flaticon-scale', subtitle: 'Get Free', title: 'Expert Advice' },
    { icon: 'fi flaticon-scale', subtitle: 'Get Free', title: 'Expert Advice' },
    { icon: 'fi flaticon-network', title: 'Join Our Team', subtitle: 'You Can Easily You Can EasilyYou Can EasilyYou Can EasilyYou Can EasilyYou Can EasilyYou Can EasilyYou Can EasilyYou Can EasilyYou Can EasilyYou Can EasilyYou Can EasilyYou Can Easily',},
]
const Service = props => {
    return (
        <div className={props.className}>
            <div className="container">
                <div className="row">
                    {services.map((service, i) => (
                        <div key={i} className="col-lg-3 col-md-4">
                            <div className="serviceItem">
                                <div className="serviceIcon">
                                    <i className={service.icon}></i>
                                </div>
                                <div className="serviceText">
                                    <span>{service.subtitle}</span>
                                    <h3>{service.title}</h3>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    )
}
export default Service